import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { PopupMessagesComponent } from '../_components/popup-messages/popup-messages.component';
import { Message } from '../_models/Message';
import { Security } from '../_helpers/security.util';
import { MsalService } from '@azure/msal-angular';


@Injectable()
export class AuthenticationService {
    private apiUrl: string;
    private messageModel: Message;
    

    constructor(private http: HttpClient, private msalService : MsalService, private dialog?: MatDialog) {}

    login(tokenAuthorize:string) {

        this.apiUrl = `${environment.apiUrl}/api/Token/authorize`;
        const hdrs = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });
        return this.http.post<any>(this.apiUrl, { tokenAuthorize: tokenAuthorize }, { headers: hdrs })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.accessToken) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                } else {
                    this.messageModel = new Message(
                        'Problema ao realizar o login',
                        'O usuário não possui acesso ao sistema. Solicite acesso via Gestão Identidade.',
                        '',
                        'error');
                    this.dialog.open(PopupMessagesComponent, { data: this.messageModel });
                }

                return user;
            }));
    }

    logout() {
        localStorage.removeItem('currentUser');
        Security.removeTokenAd();
        this.msalService.logout();
    }

    getProfile(){
        const GRAPH_ENPOINT_URL = 'https://graph.microsoft.com/v1.0/me?$select=givenName,surname,userPrincipalName,id,companyName';
        return this.http.get<any>(GRAPH_ENPOINT_URL);
    }
}
